// Sidebar.tsx
import { LogoIcon } from '@pancakeswap/uikit'
import React from 'react'
import SidebarFooter from './components/SidebarFooter'
import SideMenu from './components/SideMenu'
import WalletCard from './components/WalletCard'
import { menuConfig } from './menuConfig'
import { Aside, LogoText, LogoWrapper, MenuBlock, SideMenuWrapper } from './styled'

type SidebarProps = {
  // Define your prop types here (if any)
}

const Sidebar = React.forwardRef<HTMLDivElement, SidebarProps>((_, ref) => {
  return (
    <Aside ref={ref}>
      <LogoWrapper>
        <LogoIcon style={{ width: '29px', height: '36px' }} />
        <LogoText>Alchemy</LogoText>
      </LogoWrapper>
      <WalletCard />
      <SideMenuWrapper>
        <MenuBlock>
          {menuConfig.map((item) => (
            <SideMenu key={item.id} item={item} />
          ))}
        </MenuBlock>
        <SidebarFooter />
      </SideMenuWrapper>
    </Aside>
  )
})
export default Sidebar
